import { CardListItemRadioButton } from '@latitude/card-list-item';
import { FormRadioButtonGroup } from 'components/FormRadioButtonGroup';
import type { FieldValues } from 'react-hook-form';

import type { FormRadioCardListProps, RadioCardListOption } from './types';

const FormRadioCardList = <
  OptionType extends RadioCardListOption = RadioCardListOption,
  T extends FieldValues = FieldValues,
>({
  hideRadioButton,
  ...restProps
}: FormRadioCardListProps<OptionType, T>) => (
  <FormRadioButtonGroup<OptionType, T>
    {...restProps}
    render={(option, radioProps) => {
      // Extract the props we need for CardListItemRadioButton
      const {
        value,
        checked,
        onValueChange,
        disabled,
        invalid,
        onBlur,
        'data-testid': testId,
      } = radioProps;

      return (
        <CardListItemRadioButton
          hideRadioButton={hideRadioButton}
          value={value}
          checked={checked}
          onValueChange={onValueChange}
          disabled={disabled ?? option.disabled}
          invalid={invalid}
          onBlur={onBlur}
          radioTestId={option.testId ?? testId}
          title={option.title}
          subtitle={option.subtitle}
          trailing={option.trailing}
        />
      );
    }}
  />
);

export default FormRadioCardList;
